import React from "react";
import { NextPage } from "next";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { articlesSlice } from "@common/redux/slices/articles.slice";
import { Layout } from "@kursk/components/Layout/Layout";
import { HeaderBlock } from "@kursk/components/ui/HeaderBlock/HeaderBlock";
import { ContentBlock } from "@kursk/components/ui/ContentBlock/ContentBlock";
import { SocialLinks } from "@kursk/components/ui/SocialLinks/SocialLinks";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { Socials } from "@kursk/components/pages/Home/Socials/Socials";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import styles from "./SingleArtefact.module.scss";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";

export const SingleArtefact: NextPage = () => {
  const { article } = useSelectSlice(articlesSlice);
  const { forArticlesArtefacts } = useSelectSlice(recommendationSlice);

  if (!article) {
    return <></>;
  }
  return (
    <Layout key={`artefact_${article._id}`}>
      <SeoMetaTitles page="singleArtefact" entity={{
        name: article.name,
        seo: article.seo,
        image: article.image,
      }} showOgImage={true}/>
      <section className={styles.place_header}>
        <HeaderBlock
          entityType={'artefacts'}
          entity={article}
          goBack={'/artefacts'}
          goBackTitle={'вернуться к списку гидов'}
          customBuyButton={<div/>}
          customBreadCrumb={{
            title: null,
            link: null,
          }}
        />
      </section>
      <section className={styles.place_socialLinks}>
        <SocialLinks/>
      </section>
      <section className={styles.place_content}>
        <ContentBlock content={article.content} source={article?.source}/>
      </section>
      <section className={styles.place_recommendations}>
        <RecommendationsBlock
          entityType="overviews"
          data={forArticlesArtefacts}
          title={'также рекомендуем'}
          goTo={'/artefacts'}
          goToTitle={'все гиды'}/>
      </section>
      <section className={styles.place_socials}>
        <Socials/>
      </section>
    </Layout>
  )
}
